export const SET_HELPY_DATA = 'SET_HELPY_DATA'
export const SET_HELPY_FILTER = 'SET_HELPY_FILTER'
export const SET_INDEX = 'SET_INDEX'
export const SET_SELECTED_LEAF = 'SET_SELECTED_LEAF'
export const SET_SELECTED_NODE = 'SET_SELECTED_NODE'
export const SET_SHOW_HELPY = 'SET_SHOW_HELPY'
